import React from "react";
import { Row, Col } from "react-bootstrap";
import DocumentUploadCard from "../../../components/CustomControls/DocumentUpload/DocumentUploadCard";
import { Card } from "../../../components/Cards/Card";
import { useTranslation } from "react-i18next";
import { CustomRadio } from "../../../components/CustomControls/CustomRadio";
import {
  attachmentCategories,
  attachmentEntityType,
} from "../../../variables/Enums";
import { useAuthorization } from "../../../components/Authorization/useAuthorization";

export const DiscardedState = (props) => {
  const { t } = useTranslation();
  const { startup, setStartup, handleAttachmentChange } = props;
  const [, , isAuthorized] = useAuthorization();

  const handleStartupChange = (key, value) => {
    setStartup((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  const status = startup?.discardedType || "discard-center";
  const handleDiscardTypeChange = (eventOrName, value) => {
    const newValue = eventOrName?.target ? eventOrName.target.value : value;

    handleStartupChange("discardedType", newValue);
  };

  return (
    <>
      <div style={{ height: "20px" }} />
      <Card
        content={
          <Row>
            <Col md={12}>
              <DocumentUploadCard
                attachmentEntityTypeId={attachmentEntityType.Startup}
                entityId={startup?.id}
                protocolId={startup?.protocol?.id}
                attachment={startup?.attachments.find(
                  (x) =>
                    x.attachmentCategoryId ===
                    attachmentCategories.acceptanceFile
                )}
                legend={"Documentación de la resolución"}
                onAttachmentChange={handleAttachmentChange}
                disabled={!isAuthorized(["Startups.Edit"])}
              />
            </Col>
          </Row>
        }
      />
      <div style={{ height: "20px" }} />
      <Card
        content={
          <div className="p-3 border rounded">
            <h6>
              <strong>{t("clinicalTrials.discardTypeSubject")}</strong>
            </h6>
            <div className="text-muted mb-2">
              {t("clinicalTrials.discardTypeSubjectLegend")}
            </div>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "16px",
                marginBottom: "16px",
              }}
            >
              {["discard-center", "discard-promoter", "discard-other"].map(
                (opt) => (
                  <div key={opt} style={{ display: "inline-block" }}>
                    <CustomRadio
                      number={opt}
                      name="discard-type"
                      label={t(`clinicalTrials.startup.discardType.${opt}`)}
                      option={opt}
                      checked={startup?.discardedType === opt}
                      onChange={handleDiscardTypeChange}
                    />
                  </div>
                )
              )}
            </div>
            {(status === "discard-other" || status === "discard-promoter") && (
              <>
                <div className="text-muted mb-4">
                  {t("clinicalTrials.discardTypeOtherSubjectLegend")}
                </div>
                <textarea
                  className="form-control"
                  placeholder={t(
                    "clinicalTrials.discardTypeOtherSubjectPlaceholder"
                  )}
                  rows={4}
                  value={startup?.discardedObservation || ""}
                  onChange={(e) =>
                    handleStartupChange("discardedObservation", e.target.value)
                  }
                />
              </>
            )}
          </div>
        }
      />
    </>
  );
};

export default DiscardedState;
